'use es6';

import { makeReferenceResolver } from 'reference-resolvers/ReferenceResolver';
import emptyFunction from 'react-utils/emptyFunction';
import valueSeq from 'transmute/valueSeq';
export default makeReferenceResolver({
  all(next) {
    next(valueSeq([]));
    return emptyFunction;
  },
  byId(id, next) {
    next();
    return emptyFunction;
  }
});